import { render, staticRenderFns } from "./demo-alcohol-promo-flow-v2.vue?vue&type=template&id=52d5f98a&scoped=true&"
import script from "./demo-alcohol-promo-flow-v2.vue?vue&type=script&lang=js&"
export * from "./demo-alcohol-promo-flow-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d5f98a",
  null
  
)

export default component.exports